module.exports = __webpack_public_path__ + "static/media/pic.405d30df.png";